module.exports = __webpack_public_path__ + "static/media/cracha-informacao.30c4a8e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/cracha-informacao.svg
// module id = 1331
// module chunks = 0